var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBaloonEmpty = function SvgBaloonEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 183,
    viewBox: "0 0 219 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ballon dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M108.82 182.28C159.155 182.28 199.96 141.475 199.96 91.14C199.96 40.8048 159.155 0 108.82 0C58.4848 0 17.68 40.8048 17.68 91.14C17.68 141.475 58.4848 182.28 108.82 182.28Z",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baloon-cloud4",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M207.638 88.3381C207.077 88.3381 206.517 88.3945 205.968 88.5071C205.553 86.4138 204.213 84.6281 202.332 83.6616C200.451 82.6951 198.236 82.6545 196.322 83.5513C194.589 78.7214 189.316 76.2276 184.543 77.9811C179.771 79.7345 177.307 85.0718 179.04 89.9013C174.859 90.0351 171.557 93.5371 171.619 97.7695C171.682 102.002 175.087 105.402 179.27 105.409H207.638C212.295 105.409 216.071 101.587 216.071 96.8735C216.071 92.1595 212.295 88.3381 207.638 88.3381Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "baloon-cloud1",
    filter: "url(#filter_ud)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector2__+",
    d: "M83.9541 28.9291C83.5179 28.9291 83.0826 28.9723 82.6552 29.0583C82.3329 27.4576 81.2908 26.0921 79.8276 25.353C78.3648 24.6139 76.6419 24.5829 75.1528 25.2687C73.8053 21.5752 69.7039 19.6682 65.992 21.009C62.2802 22.3499 60.3637 26.4313 61.7112 30.1245C58.4597 30.2268 55.8913 32.9048 55.9399 36.1414C55.9888 39.3783 58.637 41.978 61.8903 41.9832H83.9541C87.5766 41.9832 90.5136 39.061 90.5136 35.4562C90.5136 31.8513 87.5766 28.9291 83.9541 28.9291Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "baloon-cloud2",
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.6872 45.8603C40.0849 45.8603 39.4838 45.9201 38.8935 46.0392C38.4484 43.8228 37.0093 41.9321 34.9887 40.9087C32.9686 39.8853 30.5894 39.8424 28.5331 40.792C26.6722 35.6779 21.0083 33.0374 15.8824 34.894C10.7565 36.7506 8.10995 42.4018 9.97085 47.5155C5.48066 47.6571 1.93379 51.3651 2.00094 55.8465C2.06849 60.3283 5.72554 63.928 10.2181 63.9352H40.6872C45.6897 63.9352 49.7456 59.889 49.7456 54.8977C49.7456 49.9064 45.6897 45.8603 40.6872 45.8603Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "baloon-cloud3",
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M164.111 61.6401C163.799 61.6401 163.488 61.67 163.183 61.7296C162.953 60.6214 162.208 59.676 161.163 59.1643C160.118 58.6527 158.888 58.6312 157.824 59.106C156.861 56.5489 153.932 55.2287 151.281 56.157C148.629 57.0853 147.26 59.9109 148.223 62.4677C145.9 62.5385 144.066 64.3925 144.1 66.6332C144.135 68.8742 146.027 70.674 148.351 70.6776H164.111C166.698 70.6776 168.796 68.6545 168.796 66.1589C168.796 63.6632 166.698 61.6401 164.111 61.6401Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "baloon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M92.1789 57.4041C78.3885 62.6977 72.1474 79.7953 78.2258 95.63C84.3042 111.465 100.383 119.995 114.173 114.701C127.963 109.407 134.205 92.3097 128.126 76.475C122.109 60.7987 106.328 52.267 92.5944 57.2489L92.1789 57.4041Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M114.562 59.8982C117.191 62.942 119.266 66.4237 120.692 70.1851C126.755 85.981 120.516 103.122 106.752 108.406C99.2937 111.122 90.995 110.195 84.3197 105.901C92.056 114.884 103.77 118.739 114.188 114.74C127.828 109.504 134.094 92.6897 128.32 76.9896L128.141 76.5142C125.643 69.7875 121.031 64.0575 115.005 60.1787L114.562 59.8982Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "baloon-hand",
    d: "M200.639 181.637C188.952 177.542 177.809 169.498 170.76 160.068C170.108 159.185 169.494 158.29 168.896 157.397L167.715 155.622C165.935 152.59 163.585 149.597 160.778 146.786C156.962 143.247 151.932 140.727 147.763 138.997L146.818 138.611L145.688 138.168L145.041 137.922C143.68 137.401 142.325 136.918 140.949 136.422C136.485 134.925 132.009 133.021 127.623 130.754C122.278 127.825 116.019 122.82 114.399 117.509L116.424 117.905C117.379 121.039 120.414 124.161 123.691 126.611L124.327 127.076C125.605 127.99 126.901 128.796 128.109 129.456C132.312 131.623 136.602 133.435 140.876 134.85C142.272 135.359 143.64 135.868 145.029 136.389L145.922 136.734L146.859 137.106C151.484 138.967 157.436 141.786 162.001 146.025C165.016 149.033 167.54 152.238 169.451 155.486C170.394 156.917 171.378 158.374 172.404 159.808C179.056 168.663 189.53 176.211 200.512 180.063L200.639 181.637Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M112.594 112.767L112.655 123.785L121.38 120.436L114.726 111.277L112.594 112.767Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M85.9223 64.1086L85.6809 64.3743L85.3169 64.8035L85.0343 65.1551L84.5953 65.7312L84.2275 66.242L83.9673 66.6194L83.6972 67.0257L83.419 67.4607L83.1347 67.9239L82.8459 68.4149L82.5545 68.9335C82.5058 69.0222 82.4571 69.112 82.4084 69.203L82.1165 69.7621L81.8265 70.3477L81.5404 70.9596C78.8453 76.895 76.9061 86.3226 82.7378 97.7891L83.0298 98.3468L82.8594 97.9562L82.6117 97.3476L82.3605 96.6878L82.1486 96.098L81.9989 95.6616L81.8441 95.192L81.6855 94.6902L81.5247 94.1575L81.3631 93.5947L81.2021 93.0032C81.1754 92.9023 81.1487 92.8002 81.1222 92.697L80.9647 92.0643L80.8114 91.4056C80.7863 91.2937 80.7614 91.1808 80.7368 91.0668L80.5924 90.3711C79.2084 83.4138 78.9468 73.0803 85.9223 64.1086Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M116.69 113.436L112.159 115.175C111.914 115.269 111.792 115.544 111.886 115.788C111.98 116.032 112.254 116.155 112.499 116.061L117.03 114.321C117.275 114.227 117.397 113.953 117.303 113.709C117.209 113.464 116.935 113.342 116.69 113.436Z",
    fill: "#3A556A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 169.618,
    y: 77.42,
    width: 48.4528,
    height: 31.9888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter_ud",
    x: 53.9392,
    y: 20.58,
    width: 38.5744,
    height: 25.4032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 0,
    y: 34.3,
    width: 51.7456,
    height: 33.6352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 142.1,
    y: 55.86,
    width: 28.696,
    height: 18.8176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgBaloonEmpty;